/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syllable Counter`)
};

const es_syl_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de sílabas`)
};

const de_syl_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silbenzähler`)
};

const nl_syl_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettergreepteller`)
};

const fr_syl_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compteur de syllabes`)
};

const it_syl_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatore di Sillabe`)
};

const pt_br2_syl_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de Sílabas`)
};

const pt_syl_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de Sílabas`)
};

const ja_syl_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音節カウンター`)
};

const zh_syl_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音节计数器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_nav_main = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_nav_main(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_nav_main", locale)
	if (locale === "en") return en_syl_nav_main(inputs)
	if (locale === "es") return es_syl_nav_main(inputs)
	if (locale === "de") return de_syl_nav_main(inputs)
	if (locale === "nl") return nl_syl_nav_main(inputs)
	if (locale === "fr") return fr_syl_nav_main(inputs)
	if (locale === "it") return it_syl_nav_main(inputs)
	if (locale === "pt-BR") return pt_br2_syl_nav_main(inputs)
	if (locale === "pt") return pt_syl_nav_main(inputs)
	if (locale === "ja") return ja_syl_nav_main(inputs)
	return zh_syl_nav_main(inputs)
};